import React from 'react'
import HeroSection from '../components/Hero/HeroSection'
import ServicesSection from '../components/Services/ServicesSection'
import ContactSection from "../components/contact/ContactSection"
import GalerySection from '../components/galery/GalerySection'

const Homepage = () => {
  return (
    <>
      <HeroSection/>
      <ServicesSection/>
      <GalerySection/>
      <ContactSection/>
    </>
  )
}

export default Homepage